export const ProductCategoryTypeEnum = Object.freeze({
  LENS: "LENS",
  NON_LENS: "NON_LENS",
});
